import { http } from '../http'
import { URL } from './_constant'

/**
 * 集体土地项目-征拆户-列表
 */
export function API_JT_ZCH_LIST(data?: BasicPageReq) {
  return http.post<ApiJtZch.ListRes>(URL.LIST, data)
}

/**
 * 集体土地项目-征拆户-全部
 */
export function API_JT_ZCH_ALL(data?: BasicPageReq) {
  return http.post<ApiJtZch.Item[]>(URL.LIST, data)
}

/**
 * 集体土地项目-征拆户-简单列表
 */
export function API_JT_ZCH_SIMPLE_LIST(data?: BasicPageReq) {
  return http.post<BasicSimpleListItem[]>(URL.SIMPLE_LIST, data)
}

/**
 * 集体土地项目-征拆户-详情
 */
export function API_JT_ZCH_DETAIL(id: string) {
  return http.post<ApiJtZch.Item>(URL.DETAIL, { id })
}

/**
 * 集体土地项目-征拆户-新增
 */
export function API_JT_ZCH_ADD(data: ApiJtZch.Item) {
  return http.post(URL.ADD, data)
}

/**
 * 集体土地项目-征拆户-删除
 */
export function API_JT_ZCH_DEL(data: ApiJtZch.DelReq) {
  return http.post(URL.DEL, data)
}

/**
 *  集体土地项目-征拆户-编辑
 */
export function API_JT_ZCH_EDIT(data: BasicUpdateOneReq<ApiJtZch.Item>) {
  return http.post(URL.EDIT, data)
}

/**
 *  集体土地项目-征拆户-禁用
 */
export function API_JT_ZCH_DISABLE(data: IdsPayload) {
  return http.post(URL.DISABLE, data)
}

/**
 * 集体土地项目-征拆户-启用
 */
export function API_JT_ZCH_ENABLE(data: IdsPayload) {
  return http.post(URL.ENABLE, data)
}

/**
 * 集体土地项目-征拆户-排序
 */
export function API_JT_ZCH_ORDER(data: BasicOrderData) {
  return http.post(URL.ORDER, data)
}

/**
 * 集体土地项目-征拆户-社保情况设置
 */
export function API_JT_ZCH_SOCIAL_SECURITY_SET(data: ApiJtZch.SocialSecurityData) {
  return http.post(URL.SOCIAL_SECURITY_SET, data)
}

/**
 * 集体土地项目-征拆户-相关照片设置
 */
export function API_JT_ZCH_RELATED_PHOTOS_SET(data: ApiJtZch.RelatedPhotosData) {
  return http.post(URL.RELATED_PHOTOS_SET, data)
}

/**
 * 集体土地项目-征拆户-拆迁补偿安置协议设置
 */
export function API_JT_ZCH_COMP_AGREEMENT_SET(data: ApiJtZch.CompAgreementData) {
  return http.post(URL.COMP_AGREEMENT_SET, data)
}

/**
 * 集体土地项目-征拆户-附件设置
 */
export function API_JT_ZCH_ATTACHMENTS_SET(data: ApiJtZch.AttachmentsData) {
  return http.post(URL.ATTACHMENTS_SET, data)
}

/**
 * 集体土地项目-征拆户-拆迁补偿数据设置
 */
export function API_JT_ZCH_COMP_DATA_SET(data: ApiJtZch.CompData) {
  return http.post(URL.COMP_DATA_SET, data)
}

/**
 * 集体土地项目-征拆户-房票补差情况设置
 */
export function API_JT_ZCH_TICKET_DIFF_SET(data: ApiJtZch.TicketDiffData) {
  return http.post(URL.TICKET_DIFF_SET, data)
}

/**
 * 集体土地项目-征拆户-城区拆迁-拆迁安置补偿协议
 */
export function API_JT_ZCH_PRINT_1(id: string) {
  return http.post<ApiJtZch.PrintRes>(URL.PRINT_1, { id })
}

/**
 * 集体土地项目-征拆户-乡镇拆迁-房票拆迁安置补偿协议
 */
export function API_JT_ZCH_PRINT_2(id: string) {
  return http.post<ApiJtZch.PrintRes>(URL.PRINT_2, { id })
}

/**
 * 集体土地项目-征拆户-乡镇拆迁-拆迁安置补偿协议
 */
export function API_JT_ZCH_PRINT_3(id: string) {
  return http.post<ApiJtZch.PrintRes>(URL.PRINT_3, { id })
}

/**
 * 集体土地项目-征拆户-房票安置价款确认书
 */
export function API_JT_ZCH_PRINT_4(id: string) {
  return http.post<ApiJtZch.PrintRes>(URL.PRINT_4, { id })
}

/**
 * 集体土地项目-征拆户-房票安置通知书
 */
export function API_JT_ZCH_PRINT_5(id: string) {
  return http.post<ApiJtZch.PrintRes>(URL.PRINT_5, { id })
}

/**
 * 集体土地项目-征拆户-放弃残值承诺书
 */
export function API_JT_ZCH_PRINT_6(id: string) {
  return http.post<ApiJtZch.PrintRes>(URL.PRINT_6, { id })
}

/**
 * 集体土地项目-征拆户-房票安置补充协议
 */
export function API_JT_ZCH_PRINT_7(id: string) {
  return http.post<ApiJtZch.PrintRes>(URL.PRINT_7, { id })
}

/**
 * 集体土地项目-征拆户-乡镇搬迁安置补偿协议
 */
export function API_JT_ZCH_PRINT_8(id: string) {
  return http.post<ApiJtZch.PrintRes>(URL.PRINT_8, { id })
}

/**
 * 集体土地项目-征拆户-城区搬迁安置补偿协议
 */
export function API_JT_ZCH_PRINT_9(id: string) {
  return http.post<ApiJtZch.PrintRes>(URL.PRINT_9, { id })
}

/**
 * 集体土地项目-征拆户-乡镇-房票搬迁安置补偿协议
 */
export function API_JT_ZCH_PRINT_10(id: string) {
  return http.post<ApiJtZch.PrintRes>(URL.PRINT_10, { id })
}

/**
 * 集体土地项目-征拆户-审核列表
 */
export function API_JT_ZCH_REVIEW_LIST(data?: BasicPageReq) {
  return http.post<ApiJtZch.ListRes>(URL.REVIEW_LIST, data)
}

/**
 * 集体土地项目-征拆户-统计
 */
export function API_JT_ZCH_TONGJI(data: IdsPayload) {
  return http.post(URL.TONGJI, data)
}

/**
 * 集体土地项目-征拆户-房票安置价款确认书（v2版本）
 */
export function API_JT_ZCH_PRINT_4_V2(data: ApiJtZch.Print4V2Req) {
  return http.post<ApiJtZch.PrintResV2>(URL.PRINT_4_V2, data)
}

/**
 * 集体土地项目-征拆户-查询房屋列表
 */
export function API_JT_ZCH_HOUSE_LIST(id: string) {
  return http.post<ApiJtZch.HouseItem[]>(URL.HOUSE_LIST, { id })
}
